import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d00db6ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pick-butterfly" }
const _hoisted_2 = { class: "container min-h-full m-auto flex flex-col text-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "mt-auto mb-0" }, "Pick Your Butterfly", -1))
const _hoisted_4 = { class: "pick-butterfly__butterflies flex-none mt-auto" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "pick-butterfly__butterfly-image flex flex-col m-auto" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "pick-butterfly__butterfly-name" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Start Customizing ")
const _hoisted_10 = { class: "flex flex-row flex-none" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link_button = _resolveComponent("router-link-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_back_button = _resolveComponent("back-button")!
  const _directive_tap = _resolveDirective("tap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.butterflies, (butterfly) => {
          return (_openBlock(), _createElementBlock("div", {
            key: butterfly,
            class: _normalizeClass(["pick-butterfly__butterfly flex-none mx-auto mb-4", {
            'pick-butterfly__butterfly--selected':
              _ctx.selectedButterfly === butterfly,
          }]),
            onClick: ($event: any) => (_ctx.onClickButterfly(butterfly))
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: _ctx.getDesignTypeSvgSrc(butterfly),
                class: "w-2/3 m-auto"
              }, null, 8, _hoisted_7)
            ]),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.getDesignTypeLabel(butterfly)), 1)
          ], 10, _hoisted_5))
        }), 128))
      ]),
      _createVNode(_component_router_link, {
        to: _ctx.nextRoute,
        custom: ""
      }, {
        default: _withCtx(({ navigate }) => [
          _withDirectives(_createVNode(_component_router_link_button, {
            class: "mx-auto mt-auto",
            disabled: !_ctx.canGoNext
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 2
          }, 1032, ["disabled"]), [
            [_directive_tap, navigate]
          ])
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_router_link, {
          to: _ctx.prevRoute,
          custom: ""
        }, {
          default: _withCtx(({ navigate }) => [
            _createVNode(_component_back_button, {
              class: "mr-auto",
              onClick: navigate
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ]))
}